export default __webpack_public_path__ + "static/media/ppt.a74e9e8d.jpg";